import { formatInTimeZone } from "date-fns-tz";
import {
  startOfDay,
  endOfDay,
  subDays,
  startOfWeek,
  startOfMonth,
  startOfQuarter,
  startOfYear,
  parseISO,
} from "date-fns";
import { NO_REPLY_EMAIL } from "./constants";
import {
  PeopleType,
  PEOPLE_TYPE,
  MESSAGE_TYPES,
  SendMessageFormValuesType,
  SendMessageType,
} from "./types";

export const getStatusFormat = (data: string) => {
  if (!data) return "--";
  else if (data === "new lead") return "New";
  else if (data === "pendactivation") return "Pending activation";
  else if (data === "pendcancel") return "Pending cancel";
  return data.slice(0, 1).toUpperCase() + data.slice(1);
};

export const getDateFormat = (data: string) => {
  if (!data) return "--";
  try {
    return formatInTimeZone(parseISO(data), "UTC", "MMM dd, yyyy");
  } catch (error) {
    return "--";
  }
};

export const handleAddClick = (type: PeopleType) => {
  // Using window.location.href to navigate to PHP pages
  if (type === PEOPLE_TYPE.MEMBERS) {
    window.location.href = "/members/add";
  } else if (type === PEOPLE_TYPE.LEADS) {
    window.location.href = "/members/lead_create";
  } else if (type === PEOPLE_TYPE.STAFF) {
    window.location.href = "/users/create";
  }
};

export const createPayload = (
  data: SendMessageFormValuesType,
  userUuids: string[],
): SendMessageType | null => {
  if (userUuids.length === 0) {
    return null;
  }

  if (data.messageType === MESSAGE_TYPES.EMAIL) {
    return {
      messageType: MESSAGE_TYPES.EMAIL,
      email: {
        to: userUuids,
        subject: data.subject,
        text: data.emailText,
        bccMe: data.bccMe,
        bccCoaches: data.bccCoaches,
        bccAdmins: data.bccAdmins,
        ...(data.replyTo !== NO_REPLY_EMAIL && {
          replyTo: data.replyTo,
        }),
      },
    };
  }
  return {
    messageType: MESSAGE_TYPES.SMS,
    sms: {
      to: userUuids,
      message: data.smsMessage,
    },
  };
};

export const getDefaultFilters = (
  setMembersFilter: boolean,
  setLeadsFilter: boolean,
) => {
  if (setMembersFilter) {
    return [{ id: "membershipRole", value: ["member"] }];
  }

  if (setLeadsFilter) {
    return [
      {
        id: "leadStatus",
        value: ["new lead", "attempted", "contacted", "in discussion"],
      },
    ];
  }
  return [];
};

export const getDateRangeForValue = (value: string) => {
  const today = new Date();
  const yesterday = subDays(today, 1);

  switch (value) {
    case "today":
      return {
        start: startOfDay(today),
        end: endOfDay(today),
      };
    case "yesterday":
      return {
        start: startOfDay(yesterday),
        end: endOfDay(yesterday),
      };
    case "week_to_date":
      return {
        start: startOfWeek(today),
        end: endOfDay(today),
      };
    case "month_to_date":
      return {
        start: startOfMonth(today),
        end: endOfDay(today),
      };
    case "quarter_to_date":
      return {
        start: startOfQuarter(today),
        end: endOfDay(today),
      };
    case "year_to_date":
      return {
        start: startOfYear(today),
        end: endOfDay(today),
      };
    case "last_7_days":
      return {
        start: startOfDay(subDays(today, 7)),
        end: endOfDay(today),
      };
    case "last_30_days":
      return {
        start: startOfDay(subDays(today, 30)),
        end: endOfDay(today),
      };
    default:
      return {
        start: startOfDay(today),
        end: endOfDay(today),
      };
  }
};
